export function loginStatus() {
  const loginContainer = document.getElementById("header-login-status");
  if (!loginContainer) return;

  const loginLink = loginContainer.querySelector(".logout-only");
  const profilLink = loginContainer.querySelector(".logged-in-only");

  // WP Rocket setzt für eingeloggte User ein auslesbares Cookie, oder wir prüfen das WP-Standard-Cookie (falls nicht HttpOnly)
  const isUserLoggedIn = document.cookie.split(";").some((item) => {
    const name = item.trim();
    return (
      name.startsWith("wordpress_logged_in_") ||
      name.startsWith("wprocket_logged_in_")
    );
  });

  // ZUSÄTZLICHER SICHERHEITS-CHECK: Falls das Skript im nicht-gecachten Zustand für Admins läuft
  const bodyHasLoggedInClass = document.body.classList.contains("logged-in");

  if (isUserLoggedIn || bodyHasLoggedInClass) {
    if (loginLink) loginLink.style.display = "none";
    if (profilLink) profilLink.style.display = "flex"; // oder 'block', je nach Design
  } else {
    if (loginLink) loginLink.style.display = "flex";
    if (profilLink) profilLink.style.display = "none";
  }
}
